import { useReportPageLoadedFromLinkClick } from '@ms/yammer-hooks/dist/pageLoad';
import { useIsLegacyPWABlocked } from '@ms/yammer-hooks/dist/pwa';
import { useEndSearchSessionEffect } from '@ms/yammer-hooks/dist/searchSession';
import React, { FC } from 'react';
import { useLocation } from 'react-router-dom';

import LegacyPWABlocked from '../PWA/Legacy/LegacyPWABlocked';
import SuiteHeader from '../SuiteHeader';

import AppLayout, { AppLayoutProps } from './AppLayout';
import LoadableWebSubHeader from './LoadableWebSubHeader';
import { useGetBannersCallback, useGetNavigationCallback } from './hooks';

export type RoutePageLayoutProps = Pick<AppLayoutProps, 'backgroundColor' | 'footer'> & {
  readonly isLeftSidebarEnabled?: boolean;
};

const Page: FC<RoutePageLayoutProps> = ({ isLeftSidebarEnabled = true, footer, backgroundColor, children }) => {
  const { pathname } = useLocation();

  const banners = useGetBannersCallback()();

  const getNavigation = useGetNavigationCallback();
  const leftNav = isLeftSidebarEnabled ? getNavigation() : undefined;

  useReportPageLoadedFromLinkClick(pathname);
  useEndSearchSessionEffect();

  const isLegacyPWABlocked = useIsLegacyPWABlocked();
  if (isLegacyPWABlocked) {
    return (
      <AppLayout backgroundColor={backgroundColor}>
        <LegacyPWABlocked />
      </AppLayout>
    );
  }

  return (
    <AppLayout
      header={<SuiteHeader />}
      banner={banners}
      leftNav={leftNav}
      subHeader={<LoadableWebSubHeader />}
      footer={footer}
      backgroundColor={backgroundColor}
    >
      {children}
    </AppLayout>
  );
};

export default Page;
